import { useEffect, useState } from "react";
import Lightbox from "react-image-lightbox";
import { baseUrl, DOWNLOAD_FILE } from "../api/endpoints";

/** Thumbnails load once, lazily; the original asset is requested only on preview. */
export default function ImageGallery({ item, choosable = false, setSelceted, listed = false }) {
  const id = typeof item === "object" ? item?.id : item;
  const [failed, setFailed] = useState(false), [open, setOpen] = useState(false);
  useEffect(() => { setFailed(false); setOpen(false); }, [id]);
  function choose() {
    if (!(Number(id) > 0)) return;
    if (choosable) setSelceted(id); else setOpen(true);
  }
  return <div className="cursor-pointer">
    <button type="button" onClick={choose} className={listed ? "w-16 h-16" : "w-full"} aria-label={choosable ? "انتخاب تصویر" : "مشاهده تصویر"}>
      <img src={id && !failed ? `${baseUrl}/${DOWNLOAD_FILE}/${id}?size=small` : "/images/no_image.svg"}
        loading="lazy" decoding="async" onError={() => setFailed(true)}
        style={listed ? undefined : { height: 190, objectFit: "contain" }}
        className={listed ? "w-16 h-16" : "w-full max-h-[190px] object-cover"}
        alt={item && typeof item === "object" ? item.alt || item.originalFileName || "تصویر" : "تصویر"} />
    </button>
    {open && <Lightbox mainSrc={`${baseUrl}/${DOWNLOAD_FILE}/${id}`} onCloseRequest={() => setOpen(false)} />}
  </div>;
}
